// extracted by mini-css-extract-plugin
module.exports = {"others":"Others_others__3-K2N"};